export const environment = {
  production: true,
  appInsights: {
    instrumentationKey: '058e1fa0-6390-40ba-8790-25b0586b52a3'
  },
  urlSegurancaApi: "#{urlSeguranca}#",
  urlComunicacaoApi: "#{urlComunicacao}#"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts